import { WaterSchedule } from '@models/Irrigation/waterSchedule';
import { SensorReadingType } from '@models/Sensor/sensorgroup.model';
import { GpsInfo } from '@models/Map/gpsInfo.model';
import { DeviceStats } from './DeviceStats.model';
import { DeviceCamera, Sensor } from '@models';

export class Device {
    id: number;
    name: string;
    description: string;
    mode: string;
    registerDate: Date;

    version?: string;
    versionInfo?: string;
    versionWarning?: boolean;
    versionTooltip?: string;

    serialNumber: string;
    macAddress: string;
    ipAddress: string;
    netmask: string;
    networkInterface: string;
    apiKey: string;
    
    gpsLocation: GpsInfo;
    sensorUUIDs: string[];
    //sensors?: Sensor[];
    waterSchedules: WaterSchedule[];
    waterRate: number;                             // in gallons per minute

    deviceNotifications: DeviceNotification[];
    notificationDestination: string;

    userName: string;
    userGroup: string;
    userGroupId: number;
    owner?: string;                                // computed display/sort value (userGroup or userName)

    aliveTimeStamp: Date;
    aliveColor: string;
    connectivity: DeviceStats[];
    ingestStats: DeviceStats[];

    userFeatureAccess?: { [key: string] : boolean }

    isDisabled: boolean;
    isDisabledColor?: string;

    checked?: boolean;
    previousUpdateMessage?: string;
    lastUpdateMessage?: string;
    updateMessages?: DeviceMessageInfo[];

    mountAngle?: number;
    deviceCameras?: DeviceCamera[];
    deviceFunctionIds?: number[];

    trustInfo?: DeviceRegistration;
}

export class DeviceRegistration {
    id: number;
    serialNumber: string;
    lastUpdated: Date;
    lastUpdatedBy: string;
    comments: string;
    isRegistered: boolean;
    isTrusted: boolean;
    isVirtual: boolean;
    expireDays: number;
    expireDate: Date;
}

export class VirtualDevice {
    jsonWebToken: string;
    serialNumber: string;
}

export class DeviceRegistrationTrustInfo {
    comment: string;
    registrationIds: number[];
}

export class DeviceNotification {
    id: number;
    type: string;
    isEnabled: boolean;
    missedCount: number;
    timeSpan: number;
    sensorValue: number;
    sensorDataType: SensorReadingType;
}

export class DeviceMessageInfo {
    id: number;
    deviceId: number;
    deviceSerial: string;
    createdDate: Date;
    message: string;
}